import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchJSON, postJSON } from 'api/fetch';
import { RootState } from 'initializers/types';

import { createReducers, createSelectors } from 'features/hiringV2/helpers';
import {
  JobRequestAPIResponse,
  JobRequestsAPIResponse,
} from 'features/hiringV2/interfaces/IJobRequest';

import { INITIAL_JOB_REQUESTS_STATE } from './constants';
import { JobRequestsState } from './types';

const SLICE_NAME = 'jobRequests';

const initialState = INITIAL_JOB_REQUESTS_STATE;

const jobRequestsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: createReducers(initialState),
});

const getJobRequestsState = (state: RootState) =>
  state.get('hiringV2').jobRequests as JobRequestsState;

// Selectors
export const jobRequestsSelectors = createSelectors(
  getJobRequestsState,
  initialState
);
export const jobRequestsActions = jobRequestsSlice.actions;

// THUNKS
export const getJobRequests = createAsyncThunk(
  `${SLICE_NAME}/getJobRequests`,
  async (_, { dispatch }) => {
    try {
      dispatch(jobRequestsActions.setJobRequestsLoading(true));
      const response = (await fetchJSON(
        `/hiring/v2/job_requests.json`
      )) as JobRequestsAPIResponse;
      dispatch(jobRequestsActions.setJobRequests(response.job_requests));
      dispatch(jobRequestsActions.setJobRequestsError(null));
      return response.job_requests;
    } catch (err) {
      const error = err as Error;
      dispatch(jobRequestsActions.setJobRequestsError(error.message));
      throw error;
    } finally {
      dispatch(jobRequestsActions.setJobRequestsLoading(false));
    }
  }
);

export const cloneJobPost = createAsyncThunk(
  `${SLICE_NAME}/cloneJobPost`,
  async (jobPostId: number) => {
    try {
      const response = await postJSON(
        `/hiring/v2/job_requests/${jobPostId}/clone`
      );
      return response as JobRequestAPIResponse;
    } catch (err) {
      const error = err as Error;
      throw error;
    }
  }
);

export const reducer = jobRequestsSlice.reducer;
